import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export class Sidebar extends Component {
    render() {
        return (
            <div>
                <div className="widget widget-nav-menu">
                    <ul className="widget-menu">
                          <li><Link to={process.env.PUBLIC_URL + '/salesforce-product-development'}>Product Development with Salesforce</Link></li>
                          <li><Link to={process.env.PUBLIC_URL + '/salesforce-implementation-services'}>Implementation Services</Link></li>
                            <li><Link to={process.env.PUBLIC_URL + '/salesforce-support-services'}>Support Services</Link></li>
                             <li><Link to={process.env.PUBLIC_URL + '/salesforce-customization-configuration-services'}>Customization Services</Link></li>
                              <li><Link to={process.env.PUBLIC_URL + '/salesforce-integrated-solution'}>Integration Services</Link></li>
                               <li><Link to={process.env.PUBLIC_URL + '/salesforce-lightning-development'}>Classic to Lightning Migration</Link></li>
                        <li><Link activeClassName="active" to={process.env.PUBLIC_URL + '/salesforce-consulting-services'}>Consulting Services</Link></li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Sidebar;